import { Directive, HostListener } from '@angular/core';

/** Anchors activate on Enter natively but not Space; CMS renders them via innerHTML so they cannot be bound individually. */
@Directive({
  selector: '[appLinkSpacebarActivation]',
})
export class LinkSpacebarActivationDirective {
  /** Browser scrolls on keydown, so suppress it there and activate on keyup to match A11yActionDirective. */
  @HostListener('keydown.space', ['$event'])
  onSpacebarKeydown(event: KeyboardEvent): void {
    if (event.target instanceof HTMLAnchorElement) {
      event.preventDefault();
    }
  }

  @HostListener('keyup.space', ['$event'])
  onSpacebarKeyup(event: KeyboardEvent): void {
    const target = event.target;
    if (!(target instanceof HTMLAnchorElement)) {
      return;
    }
    event.preventDefault();
    target.click();
  }
}
